import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import 'quill/dist/quill.snow.css';

import { Content } from './Styles';
import { ANCHOR_TAG } from '../TextEditor';

const propTypes = {
  content: PropTypes.string.isRequired,
};

const TextEditedContent = ({ content, ...otherProps }) => {
  const handleLinkClick = (e) => {
    if (e.target.tagName === ANCHOR_TAG) {
      e.preventDefault();
      window.open(e.target.href, '_blank', 'noopener,noreferrer');
      window.focus();
    }
  };

  return (
    <div
      className="ql-snow"
      style={{ fontSize: '15px', fontWeight: 'medium', overflow: 'auto' }}>
      <Content
        className="ql-editor"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        onClick={handleLinkClick}
        {...otherProps}
      />
    </div>
  );
};

TextEditedContent.propTypes = propTypes;

export default TextEditedContent;
